<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <!-- <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        /> -->
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <img :src="logo" style="max-width:50%;" class="mx-auto"/>
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  
                  <h4 class="font-weight-bolder">Bienvenido</h4>
                  <p class="mb-0">Introduzca sus credenciales para iniciar sesión</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="" >
                    <div class="mb-3">
                      <argon-input 
                      type="text" placeholder="Email" 
                      name="email" size="lg" 
                      v-model="user.username"/>
                    </div>
                    <div class="mb-3">
                      <argon-input 
                      type="password" placeholder="Contraseña" 
                      name="password" size="lg" 
                      v-model="user.password"/>
                    </div>
                    <argon-switch id="rememberMe">Recordar</argon-switch>

                    <div class="text-center">
                      <argon-button
                        type="submit" 
                        class="mt-4"
                       
                        color="success"
                        fullWidth
                        size="lg"
                        @click="login"
                      >Acceder</argon-button>
                    </div>
                  </form>
                </div>
                <!-- <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    Don't have an account?
                    <a
                      href="javascript:;"
                      class="text-success text-gradient font-weight-bold"
                    >Sign up</a>
                  </p>
                </div> -->
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-info h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="background-image: url('https://images.hl.uk/vvl3z0p6qtad/6gKc62uEc0vXV5J2Ax6f7i/05e47184e0894144b36840cc4d4b4508/Financial_data_analysis_graph_showing_global_market_trends_-_Gettyimages.jpg');
          background-size: cover;"
              >

                <span class="mask bg-info opacity-41"></span>
                <img style="max-width:50%;" class="position-relative mx-auto" :src="logo">

                <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >"Esta es una versión demo"</h4>
                <p
                  class="text-white position-relative"
                >En The Real Devs estamos trabajando para brindarles un mejor servicio</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
//import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import axios from 'axios';
import qs from 'qs';
import logo from "@/assets/img/logo.png";
const body = document.getElementsByTagName("body")[0];
export default {
  name: "signin",
  components: {
    //Navbar,
    ArgonInput,
    ArgonSwitch,
    ArgonButton,
    
  },
  data(){
    return{
      logo,
      user:{
        username:null,
        password:null,
      }
    }
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods:{
    login(){
      let self=this;
      //let data="?action=login&username=" + this.user.email + "&password=" + this.user.password;
      console.log(self.user);
      const config = {
        headers: {
          // Es crucial para replicar '-H 'Content-Type: application/x-www-form-urlencoded''
          'Content-Type': 'application/x-www-form-urlencoded',
          'accept': '*/*'
        }
      };
      axios.post(self.$store.state.apiURL+'login',qs.stringify(self.user),config)
      .then((result)=> {
        console.log(result)
        localStorage.setItem('userId',result.data.userid);
        localStorage.setItem('userEmail',result.data.username);
        localStorage.setItem('userLevel',result.data.userlevelid);
        localStorage.setItem('accessToken',result.data.JWT);
        self.$router.push('/'); 
      })
    }
  }
};
</script>
